import { css } from 'linaria';

export const collectionListSection = css`
  @media (--only-desktop) {
    margin-bottom: 80px;
  }
`;

export const collectionListTitle = css`
  && {
    margin-bottom: 16px;

    @media (--to-desktop) {
      margin-bottom: 24px;
    }
  }
`;

export const collectionListSubtitle = css`
  && {
    margin-bottom: 24px;
    line-height: 28px;
  }
`;

export const collectionsGrid = css`
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: repeat(3, 377px);
  padding: 0;
  margin: 0;
  column-gap: 24px;
  list-style: none;
  row-gap: 24px;

  @media (--only-desktop) {
    grid-template-columns: repeat(2, 458px);
  }

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 318px);
  }

  @media (--only-mobile) {
    grid-template-columns: repeat(1, 100%);
    column-gap: 0;
    row-gap: 16px;
  }
`;

export const collectionContentLink = css`
  && {
    height: 100%;
  }
`;

export const collectionPriceWrapper = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

export const collectionPriceView = css`
  margin-bottom: 12px;
`;

export const collectionButton = css`
  && {
    padding: 10px;
    margin-top: auto;
    text-align: center;
    background-color: var(--control-minor);
    border-radius: var(--rounding-m);

    a:hover & {
      background-color: var(--control-hover-minor);
    }
  }
`;

export const collectionButtonDisabled = css`
  && {
    padding: 8px;
    margin-top: auto;
    text-align: center;
    background-color: transparent;
    border: 2px solid var(--control-secondary);
    border-radius: var(--rounding-m);
    opacity: 0.4;
    user-select: none;
  }
`;
